import React from 'react';
import { getStateIconProps } from '../../../utils/stateIconUtils';

/**
 * StateIcon Component - Displays state-specific icon based on trip destination
 * @param {string} destination - Trip destination to extract state from
 * @param {number} size - Icon size (default: 24)
 * @param {boolean} showAbbr - Whether to show state abbreviation (default: false)
 * @param {string} className - Additional CSS classes
 */
const StateIcon = ({ destination, size = 24, showAbbr = false, className = '' }) => {
  const stateIcon = getStateIconProps(destination);

  return (
    <div 
      className={`flex items-center justify-center ${className}`}
      style={{ 
        fontSize: `${size}px`,
        lineHeight: 1
      }}
      title={`${stateIcon?.name} State`}
    >
      <span role="img" aria-label={`${stateIcon?.name} state icon`}>
        {stateIcon?.emoji}
      </span>
      {showAbbr && stateIcon?.abbr && (
        <span 
          className="ml-1 font-heading font-heading-semibold text-xs"
          style={{ 
            color: stateIcon?.color,
            fontSize: `${size * 0.5}px`
          }}
        >
          {stateIcon?.abbr}
        </span>
      )}
    </div>
  );
};

export default StateIcon;